module.exports = __webpack_public_path__ + "img/assuraf_sm1.325759ae.png";